export const enum PolicyType {
  LIBERAL = "LIBERAL",
  FASCIST = "FASCIST",
}

export const enum Role {
  LIBERAL = "LIBERAL",
  FASCIST = "FASCIST",
  HITLER = "HITLER",
}
